import { Routes } from '@angular/router';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { MinimalLayoutComponent } from './layout/minimal-layout/minimal-layout.component';
import { languageGuard } from './core/i18n/language.guard';
import { languageResolver } from './core/i18n/language.resolver';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/lang-redirect/lang-redirect.component').then(
        (m) => m.LangRedirectComponent,
      ),
  },
  {
    path: ':lang',
    canActivate: [languageGuard],
    resolve: { language: languageResolver },
    children: [
      {
        path: '',
        component: MainLayoutComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/home/home.component').then(
                (m) => m.HomeComponent,
              ),
          },
          {
            path: 'platform/overview',
            loadComponent: () =>
              import('./pages/platform/overview/overview.component').then(
                (m) => m.OverviewComponent,
              ),
          },
          {
            path: 'platform/smart-locks',
            loadComponent: () =>
              import(
                './pages/platform/smart-locks/smart-locks.component'
              ).then((m) => m.SmartLocksComponent),
          },
          {
            path: 'platform/property-intelligence',
            loadComponent: () =>
              import(
                './pages/platform/property-intelligence/property-intelligence.component'
              ).then((m) => m.PropertyIntelligenceComponent),
          },
          {
            path: 'platform/ai-messaging-concierge',
            loadComponent: () =>
              import(
                './pages/platform/ai-messaging-concierge/ai-messaging-concierge.component'
              ).then((m) => m.AiMessagingConciergeComponent),
          },
          {
            path: 'platform/for-guests',
            loadComponent: () =>
              import('./pages/platform/for-guests/for-guests.component').then(
                (m) => m.ForGuestsComponent,
              ),
          },
          {
            path: 'platform/for-service-providers',
            loadComponent: () =>
              import(
                './pages/platform/for-service-providers/for-service-providers.component'
              ).then((m) => m.ForServiceProvidersComponent),
          },
          {
            path: 'pricing',
            loadComponent: () =>
              import('./pages/pricing/pricing.component').then(
                (m) => m.PricingComponent,
              ),
          },
          {
            path: 'become-a-partner',
            loadComponent: () =>
              import(
                './pages/become-a-partner/become-a-partner.component'
              ).then((m) => m.BecomeAPartnerComponent),
          },
          {
            path: 'about-us',
            loadComponent: () =>
              import('./pages/about-us/about-us.component').then(
                (m) => m.AboutUsComponent,
              ),
          },
          {
            path: 'sign-in',
            loadComponent: () =>
              import('./pages/sign-in/sign-in.component').then(
                (m) => m.SignInComponent,
              ),
          },
          {
            path: 'book-a-demo',
            loadComponent: () =>
              import('./pages/book-a-demo/book-a-demo.component').then(
                (m) => m.BookADemoComponent,
              ),
          },
        ],
      },
      {
        path: '404',
        component: MinimalLayoutComponent,
        children: [
          {
            path: '',
            loadComponent: () =>
              import('./pages/not-found/not-found.component').then(
                (m) => m.NotFoundComponent,
              ),
          },
        ],
      },
    ],
  },
  { path: '**', redirectTo: '/en/404', pathMatch: 'full' },
];
